/**
 * Session-replay privacy settings, shared by every PostHog instance we run:
 * the main app (instrumentation-client.ts) and the record-only instance inside
 * the BlinkLab frames (src/lib/server/blinklabFrameRecorder.ts →
 * public/analytics/blinklab-frame-recorder.js). One source so the two can
 * never drift apart.
 *
 * Inputs are masked by default; mark sensitive UI with data-ph-mask, and opt
 * elements out entirely with .ph-no-capture.
 */
export const REPLAY_MASKING = {
  maskAllInputs: true,
  maskTextSelector: "[data-ph-mask]",
  blockSelector: ".ph-no-capture",
} as const;
